import { UserRepository } from "../../repositories/UserRepository";

/**
 * Delete User Use Case
 * Soft deletes a user
 */
export class DeleteUserUseCase {
  constructor(private repository: UserRepository) {}

  async execute(userId: number): Promise<void> {
    if (!userId || userId <= 0) {
      throw new Error("Valid user ID is required");
    }

    await this.repository.deleteUser(userId);
  }
}

